import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Button, message } from "antd";
import { EditCampousers, obtenerCamposUser } from "../../../services/formularioUsuarios";

const EditarCampoModal = ({ isEditModalOpen, setIsEditModalOpen, selectedCampo, rolesDisponibles, setCampos }) => {
  const [form] = Form.useForm();

  const parseOpciones = (opcionesStr) => {
    try {
      return opcionesStr.replace(/[{}"]/g, "").split(",").map(op => op.trim());
    } catch (error) {
      console.error("Error al parsear opciones:", error);
      return [];
    }
  };

  const handleEditSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        campo: values.campo,
        tipo_campo: values.tipo_campo,
        opciones: values.tipo_campo === "select" ? `{${values.opciones.map(op => `"${op}"`).join(",")}}` : null,
        roles: values.roles.map((rolId) => ({
          directus_roles_id: { id: rolId },
        })),
      };
      await EditCampousers(selectedCampo.id, payload);
      const data = await obtenerCamposUser();
      setCampos(data);
      message.success("Campo actualizado correctamente");
      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Error al editar el campo:", error);
      message.error("Error al editar el campo");
    }
  };

  useEffect(() => {
    if (selectedCampo) {
      form.setFieldsValue({
        campo: selectedCampo.campo,
        tipo_campo: selectedCampo.tipo_campo,
        opciones: selectedCampo.tipo_campo === "select" ? parseOpciones(selectedCampo.opciones) : undefined,
        roles: selectedCampo.roles?.map((rol) => rol.directus_roles_id.id),
      });
    }
  }, [selectedCampo, form]);

  return (
    <Modal
      title={`Editar Campo: ${selectedCampo?.campo}`}
      open={isEditModalOpen}
      onCancel={() => setIsEditModalOpen(false)}
      onOk={handleEditSubmit}
      okText="Guardar"
      cancelText="Cancelar"
      width={600}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="campo"
          label="Nombre del Campo"
          rules={[{ required: true, message: "Ingresa el nombre del campo" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="tipo_campo"
          label="Tipo de Campo"
          rules={[{ required: true, message: "Selecciona el tipo de campo" }]}
        >
          <Select placeholder="Selecciona el tipo">
            <Select.Option value="texto">Texto</Select.Option>
            <Select.Option value="numero">Número</Select.Option>
            <Select.Option value="select">Select</Select.Option>
            <Select.Option value="fecha">Fecha</Select.Option>
            <Select.Option value="imagen">Imagen</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.tipo_campo !== currentValues.tipo_campo
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("tipo_campo") === "select" ? (
              <Form.Item
                name="opciones"
                label="Opciones (Separadas por comas)"
                rules={[
                  { required: true, message: "Ingresa las opciones del select" },
                ]}
              >
                <Select
                  mode="tags"
                  tokenSeparators={[","]}
                  placeholder="Ingresa las opciones"
                />
              </Form.Item>
            ) : null}
        </Form.Item>

        <Form.Item
          name="roles"
          label="Roles Asociados"
          rules={[{ required: true, message: "Selecciona al menos un rol" }]}
        >
          <Select
            mode="multiple"
            placeholder="Selecciona los roles"
            options={rolesDisponibles.map((rol) => ({
              label: rol.name,
              value: rol.id,
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditarCampoModal; 